/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  GetWorkflowNotificationSettingsResponse,
  UpdateWorkflowNotificationSettingsRequestBody,
  UpdateWorkflowNotificationSettingsResponse
} from '../model';

import getWorkflowNotificationSettingsMutator from '../../../mutators/datastore-instance';
import putWorkflowNotificationSettingsMutator from '../../../mutators/datastore-instance';



  /**
 * ワークフロー通知設定を取得する
 * @summary ワークフロー通知設定取得
 */
export const getWorkflowNotificationSettings = (

 ) => {
      return getWorkflowNotificationSettingsMutator<GetWorkflowNotificationSettingsResponse>(
      {url: `/workflow-notification-settings`, method: 'GET'
    },
      );
    }
  /**
 * ワークフロー通知設定を更新する
 * @summary ワークフロー通知設定更新
 */
export const putWorkflowNotificationSettings = (
    updateWorkflowNotificationSettingsRequestBody?: UpdateWorkflowNotificationSettingsRequestBody,
 ) => {
      return putWorkflowNotificationSettingsMutator<UpdateWorkflowNotificationSettingsResponse>(
      {url: `/workflow-notification-settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWorkflowNotificationSettingsRequestBody
    },
      );
    }
  export type GetWorkflowNotificationSettingsResult = NonNullable<Awaited<ReturnType<typeof getWorkflowNotificationSettings>>>
export type PutWorkflowNotificationSettingsResult = NonNullable<Awaited<ReturnType<typeof putWorkflowNotificationSettings>>>
